import type {
    Graph,
    GraphFilters,
} from "@station/domain/models/graph.model.ts";
import type { GraphRepository } from "@station/domain/repositories/graph.repository.ts";
import { stationsTypes } from "@station/station-types.di.ts";
import { inject, injectable } from "inversify";

@injectable()
export class GraphsGetByUseCase {
    constructor(
        @inject(stationsTypes.repositories.GraphRepository)
        private readonly graphRepository: GraphRepository,
    ) {}

    async execute(filter: GraphFilters): Promise<Graph[]> {
        const graphResult = await this.graphRepository.fetchById(filter);

        if (graphResult.isErr()) {
            throw new Error("Error getting graph data");
        }

        return graphResult.match(
            (graph) => graph,
            () => [],
        );
    }
}
